import DocumentTypeStore from 'documents/DocumentTypeStore'
import Workspace from 'iam/models/Workspace'
import { FilterItem } from 'infra/FiltersViewModel'
import { FindJobsQuery } from 'jobs/dtos/job'
import JobSearchStore from 'jobs/views/JobManagement/JobSearchStore'
import { CursorPaged, Id } from 'types/definitions'

export interface DocumentsLoadFilterItemsPorts {
  getWorkspaces: () => FilterItem<Id>[]
  fetchSearchableJobs: (
    query: FindJobsQuery,
  ) => Promise<CursorPaged<FilterItem<Id>>>
  fetchDocumentTypes: () => Promise<FilterItem<Id>[]>
}

export class DocumentsLoadFilterItemsAdapter
  implements DocumentsLoadFilterItemsPorts
{
  constructor(
    private getAvailableWorkspaces: () => Workspace[],
    private documentTypeStore: DocumentTypeStore,
    private jobSearchStore: JobSearchStore,
  ) {}

  /**
   * Get available workspaces, and return as filter items.
   */
  getWorkspaces(): FilterItem<Id>[] {
    return this.getAvailableWorkspaces().map((w) => {
      return {
        title: w.name,
        value: w.id,
      }
    })
  }

  /**
   * Fetch searchable jobs, and return as paginated filter items.
   */
  async fetchSearchableJobs(
    query: FindJobsQuery,
  ): Promise<CursorPaged<FilterItem<Id>>> {
    return this.jobSearchStore.searchJobs(query).then((jobs) => ({
      ...jobs,
      data: jobs.data.map((job) => ({
        title: job.displayName,
        description: job.legendName,
        value: Id(job.id),
      })),
    }))
  }

  /**
   * Fetch document types, and return as filter items.
   */
  async fetchDocumentTypes(): Promise<FilterItem<Id>[]> {
    return this.documentTypeStore.fetchTypes().then((dt) =>
      dt.map((dt) => {
        return {
          title: dt.name,
          description: dt.shortHelpText,
          value: dt.id,
        }
      }),
    )
  }
}
